/** Matches comparison/[id]/page: collection pills, delete, sort row, candidate grid */
export default function ComparisonDetailPageSkeleton() {
  return (
    <div className="skeleton-stage p-6 w-full" aria-busy aria-label="Loading">
      <div className="flex flex-col gap-6 bg-white rounded-xl p-6">
        <div className="flex justify-between items-center gap-4 flex-wrap">
          <div className="flex gap-2 flex-wrap flex-1">
            {[1, 2, 3].map((i) => (
              <div
                key={i}
                className="h-9 min-w-[100px] rounded-full skeleton-shimmer shrink-0"
              />
            ))}
          </div>
          <div className="h-9 w-28 rounded-md skeleton-shimmer shrink-0" />
        </div>

        <div className="flex gap-4 flex-wrap">
          {["Newest", "Oldest", "Rating"].map((label) => (
            <div
              key={label}
              className="h-9 w-28 rounded-full skeleton-shimmer shrink-0"
            />
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
          {[1, 2, 3].map((i) => (
            <div
              key={i}
              className="rounded-xl bg-white p-6 flex flex-col items-center border border-gray-200"
            >
              <div className="h-20 w-20 rounded-full skeleton-shimmer mb-4" />
              <div className="h-5 w-32 skeleton-shimmer rounded mb-2" />
              <div className="h-4 w-24 skeleton-shimmer rounded mb-4" />
              <div className="h-4 w-40 skeleton-shimmer rounded mb-4" />
              <div className="flex gap-2 mb-4">
                <div className="h-7 w-24 rounded-full skeleton-shimmer" />
                <div className="h-7 w-20 rounded-full skeleton-shimmer" />
              </div>
              <div className="flex gap-1 mb-2">
                {[1, 2, 3, 4, 5].map((s) => (
                  <div key={s} className="h-4 w-4 rounded skeleton-shimmer" />
                ))}
              </div>
              <div className="h-3 w-36 skeleton-shimmer rounded" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
